// Accordion functionality - keeps filters closed by default
const parent = document.querySelectorAll(".facets-container");
const mobileParent = document.querySelectorAll("#main-collection-filters-mobile");
let eventAttached = false;

// Initialize filter states to ensure they start closed
function initializeFilters() {
    // Initialize desktop filters - ensure all start closed
    parent.forEach(element => {
        const filterAttributes = element.querySelectorAll(".filter-attribute");
        filterAttributes.forEach(attr => {
            attr.style.display = "none";
        });
        
        const filterTitles = element.querySelectorAll(".filter-title");
        filterTitles.forEach(title => {
            title.classList.remove("opened");
        });
        
        const detailsElements = element.querySelectorAll("details");
        detailsElements.forEach(details => {
            details.removeAttribute("open");
        });
    });
    
    // Initialize mobile filters - ensure all start closed
    mobileParent.forEach(element => {
        const filterAttributes = element.querySelectorAll(".filter-attribute");
        filterAttributes.forEach(attr => {
            attr.style.display = "none";
        });
        
        const filterTitles = element.querySelectorAll(".filter-title");
        filterTitles.forEach(title => {
            title.classList.remove("opened");
        });
        
        const detailsElements = element.querySelectorAll("details");
        detailsElements.forEach(details => {
            details.removeAttribute("open");
        });
    });
}

function actionFilter() {
    if (!eventAttached) {
        // Initialize once when binding events for the first time
        initializeFilters();

        // Desktop filters
        if (parent.length != 0) {
            parent.forEach(element => {
                element.addEventListener("click", function (event) {
                    handleFilterClick(event, element);
                });
            });
        }
        
        // Mobile filters
        if (mobileParent.length != 0) {
            mobileParent.forEach(element => {
                element.addEventListener("click", function (event) {
                    handleFilterClick(event, element, true);
                });
            });
        }
       
        eventAttached = true;
    }
}

function handleFilterClick(event, element, isMobile = false) {
    const target = event.target;
    
    // Check if we clicked on a filter title or something inside it
    if (target.matches(".filter-title") || target.closest(".filter-title")) {
        // Don't prevent default if clicking on inputs or labels inside the title
        if (target.matches("input") || target.matches("label") || target.closest("label")) {
            return;
        }
        
        event.preventDefault();
        event.stopPropagation();
        
        const filterTitle = target.matches(".filter-title") ? target : target.closest(".filter-title");
        const filterAttribute = filterTitle.closest("action-filter")?.querySelector(".filter-attribute");
        const detailsElement = filterTitle.closest("details");
        
        if (filterAttribute && detailsElement) {
            // Check if currently hidden (no open attribute)
            const isHidden = !detailsElement.hasAttribute("open");
            
            if (isHidden) {
                // Show it - add open attribute first, then animate
                detailsElement.setAttribute("open", "");
                filterAttribute.style.display = "block";
                
                if (typeof slideAnime === "function") {
                    slideAnime({
                        target: filterAttribute,
                        parent: filterTitle,
                        animeType: "slideDown",
                    });
                } else {
                    filterAttribute.style.display = "block";
                    filterTitle.classList.add("opened");
                }
            } else {
                // Hide it
                if (typeof slideAnime === "function") {
                    slideAnime({
                        target: filterAttribute,
                        parent: filterTitle,
                        animeType: "slideUp",
                    });
                    setTimeout(() => {
                        detailsElement.removeAttribute("open");
                    }, 250);
                } else {
                    filterAttribute.style.display = "none";
                    filterTitle.classList.remove("opened");
                    detailsElement.removeAttribute("open");
                }
            }
        }
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        initializeFilters();
        actionFilter();
    });
} else {
    initializeFilters();
    actionFilter();
}